<div class="main-page">
  <app-header></app-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <br><br>
   <div class="reset-password-top">
    <div class="innerPage reset-password">
	   <div class="sigup-screen-area">
	 <span class="nav-divnk">Change Password</span>
	 </div>
     <div class="content-part"><img src="assets/logo-5.png"></div>
        <form class="reset-password-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" >
          <div class="form-group">
            <label for="otp" class="form-label">OTP</label>
            <input id="otp" type="number" class="form-control" formControlName="otp" placeholder="Enter OTP"  [ngClass]="{ 'is-invalid': submitted && f.otp.errors }">
            <div *ngIf="submitted && f.otp.errors" class="invalid-feedback">
              <div *ngIf="f.otp.errors.required">Otp is required</div>
            </div>
          </div>
          <div class="form-group position-relative">
            <label for="password" class="form-label">New Password</label>
            <input id="password" [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Password"  [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
            <button type="button" class="btn btn-link p-0 position-absolute toggle-eye" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
              <i [class]="showPassword ? 'fa fas fa-eye' : 'fa fas fa-eye-slash'"></i>
            </button>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Password is required</div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary">Send</button>
        </form>
  </div>
  </div>
  </div>
  